module.exports = __webpack_public_path__ + "static/media/foot.4746f05b.png";